import HTTP from './http'
import { getToken } from 'utils/auth'
import { API_HEADER_CONTENT_TYPE as HEADER } from './constants'
import { IHTTPVerbsData } from './interface'

// FILE TYPES GET ······························································
export const fileTypesGet = ({ token }: IHTTPVerbsData) =>
  HTTP.onboarding.get('/v1/documents-service/file-types', {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.json
    }
  })
// FILES GET ······························································
export const filesGet = ({ id }: IHTTPVerbsData) =>
  HTTP.onboarding.get(`/v1/documents-service/files?ownerId=${id}`, {
    headers: {
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.json
    }
  })
